interface CtaBannerProps {
  onBookDemo?: () => void;
  onOpenDemo?: () => void;
}

export default function CtaBanner({ onBookDemo, onOpenDemo }: CtaBannerProps) {
  const handleDemo = onBookDemo || onOpenDemo;
  return (
    <section className="py-20 lg:py-28 bg-[#070e1c] text-white">
      <div className="w-full max-w-[1200px] mx-auto px-8 relative z-10">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-10">
          {/* Left Column */}
          <div className="space-y-3 max-w-xl">
            <h2 className="text-3xl sm:text-4xl lg:text-[44px] font-extrabold text-white tracking-tight leading-[1.15]">
              Ready to scale your sales?
            </h2>
            <p className="text-sm sm:text-base text-slate-300">
              Book a demo and see how EchoLeads would handle your leads.
            </p>
          </div>

          {/* Right Column: Button & Contact */}
          <div className="space-y-4">
            <a
              href="https://echoleads.ai/contact"
              className="inline-block px-9 py-4 rounded-xl bg-[#F2A339] hover:bg-[#E08D26] text-slate-950 font-bold text-base transition-all transform hover:-translate-y-0.5 shadow-lg shadow-[#F2A339]/25 cursor-pointer text-center"
            >
              Book a demo
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
